import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { api, formatApiError } from "@/lib/api";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function SponsorshipThankYou() {
  const [params] = useSearchParams();
  const ref = params.get("reference") || params.get("trxref");
  const [res, setRes] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    if (!ref) { setErr("No sponsorship reference found."); return; }
    api.get(`/sponsorships/verify/${ref}`).then(({ data }) => setRes(data)).catch((e) => setErr(formatApiError(e)));
  }, [ref]);
  return (
    <div>
      <Navbar />
      <main className="max-w-xl mx-auto px-4 py-20 text-center" data-testid="sponsorship-thankyou">
        {!res && !err && <Loader2 className="w-10 h-10 mx-auto animate-spin text-emerald-600" />}
        {err && <><XCircle className="w-12 h-12 mx-auto text-red-500" /><p className="mt-4 text-gray-700" data-testid="sponsorship-thankyou-error">{err}</p></>}
        {res && res.paid && (
          <>
            <CheckCircle2 className="w-14 h-14 mx-auto text-emerald-600" />
            <h1 className="mt-5 font-display font-extrabold text-3xl sm:text-4xl text-emerald-950">Thank you for helping a family.</h1>
            <p className="mt-4 text-gray-600" data-testid="sponsorship-thankyou-summary">Your {res.frequency === "monthly" ? `US$${res.amount_usd}/month` : `US$${res.amount_usd} one-time`} sponsorship ({res.purpose_label}) is confirmed. Reference <b className="font-mono">{res.ref}</b>. A receipt is on its way to your email.</p>
            <Link to={res.manage_url}><Button className="mt-8 rounded-full h-12 px-6 bg-emerald-700 hover:bg-emerald-800" data-testid="sponsorship-thankyou-manage-btn">View my sponsorship</Button></Link>
          </>
        )}
        {res && !res.paid && (
          <>
            <XCircle className="w-12 h-12 mx-auto text-amber-500" />
            <h1 className="mt-5 font-display font-bold text-2xl text-emerald-950">Payment not confirmed</h1>
            <p className="mt-3 text-gray-600" data-testid="sponsorship-thankyou-pending">Paystack has not confirmed this payment (reference {res.ref}). No sponsorship has started. You can try again from the home page.</p>
            <Link to="/#sponsor-a-family"><Button variant="outline" className="mt-6 rounded-full" data-testid="sponsorship-try-again-btn">Try again</Button></Link>
          </>
        )}
      </main>
      <Footer />
    </div>
  );
}
